// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".update-attr-drawer .toggle-wrapper{margin-left:0;margin-right:0}.update-attr-drawer .toggle{display:inline-block}.update-attr-drawer i{cursor:pointer;margin-left:.5rem;margin-top:5px}", ""]);
// Exports
module.exports = exports;
